<template>
    <!-- 报名须知  政策文件 实时新闻 通知公告 关于我们 职业标准-->
    <div style="position: relative;top:115px;">
        <div class="fullSlide1">
            <div class="bd">
                <ul>
                    <li style="background:url(../../static/img/banner2.jpg) top center no-repeat;">
                        <a>&nbsp;</a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mian">
            <div class="page_box">
                <v-spin class="page_box_right" :spinning="loadingFlag" tip="" size="large">
                    <span class="layui-breadcrumb" style="visibility: visible;margin: 20px 0;">
                        <a class="shouye" @click="homePage()">首页</a>
                        <span lay-separator="">/</span>
                        <a class="target-text" href="javascript:;"
                            style="color: #f08326!important;">{{navigationName}}</a>
                    </span>
                    <div class="item-module-more-loading"
                        style="width: 100%; min-height: 300px; line-height: 300px; text-align: center; display: none;">
                        <i class="layui-icon layui-icon-loading layui-icon layui-anim layui-anim-rotate layui-anim-loop"
                            style="font-size: 30px;"></i>
                    </div>
                    <div id="fitslist" class="item-module-list" data-id="26" style="min-height: 400px">
                        <div class="index_6_2_1_4" v-for="(item,index) in tableData" :key="index"
                            style="margin-top: 20px;">
                            <div class="index_6_2_1_4_1">
                                <img :src="item.src" height="110" @error="imgerrorfun(index)" />
                            </div>
                            <div class="index_6_2_1_4_2">
                                <h2 style="margin: 35px;">
                                    <a @click="detail(item)">
                                        {{item.contentTitle}}
                                    </a>
                                    <span
                                        style="float: right;font-size: 14px;font-weight: 400;color: #999999">{{item.insertTime}}</span>
                                </h2>
                                <p></p>
                            </div>
                        </div>
                    </div>
                </v-spin>
                <!-- <div class="page_box_right">
                </div> -->
                <el-pagination style="width: 1150px;margin: 20px auto;" @size-change="handleSizeChange"
                    @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[4, 8, 10, 15]"
                    :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>
        <el-backtop>
        </el-backtop>
    </div>
</template>

<script>
    //import homePage from './components/homePage.vue';
    export default {
        name: 'app',
        components: {
            //homePage
        },
        data() {
            return {
                loadingFlag: false,
                total: 0,   //一共多少条
                pagesize: 4,  //一页几条
                currentPage: 1,//当前页
                navId: '',
                navigationName: '',
                tableData: []
            }
        },
        created() {
            this.navId = this.$route.params.navId;
            this.loadData(this.currentPage, this.pagesize);
        },
        methods: {
            homePage() {
                this.$router.push({ path: '/net' })
            },
            detail(item) {
                this.$router.push({ path: '/journalismNoticeDetailnet/' + item.id + "/" + item.navName })
            },
            imgerrorfun(index) {
                this.tableData[index].src = '../../static/img/logo.png';
            },
            //切换每页多少条 触发
            handleSizeChange(val) {
                this.pagesize = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            //第几页切换的时 触发
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loadData(this.currentPage, this.pagesize);
            },
            loadData(page, limit) {
                this.loadingFlag = true;
                let navId = 0;
                if (this.navId === '1') {
                    this.navigationName = '报名须知';
                    navId = 26;
                   // this.$parent.navigationSwitchover(1);
                } else if (this.navId === '2') {
                    this.navigationName = '政策文件';
                    navId = 27;
                   // this.$parent.navigationSwitchover(2);
                } else if (this.navId === '3') {
                    this.navigationName = '实时新闻';
                    navId = 28;
                  //  this.$parent.navigationSwitchover(3);
                } else if (this.navId === '4') {
                    this.navigationName = '通知公告';
                    navId = 29;
                   // this.$parent.navigationSwitchover(4);
                } else if (this.navId === '5') {
                    this.navigationName = '关于我们';
                    navId = 31;
                   // this.$parent.navigationSwitchover(5);
                } else if (this.navId === '6') {
                    this.navigationName = '职业标准';
                    navId = 32;

                    //this.$parent.navigationSwitchover(6);
                }
                let parames = new URLSearchParams();
                parames.append('navId', navId);
                parames.append('page', page);
                parames.append('limit', limit);
                parames.append('organStatus', this.organStatus);

                this.$axios.post(this.serverUrl + '/navList', parames).then(resp => {

                    this.total = resp.data.count;

                    if (resp.data.code === 1) {

                        let ArrayList = [];
                        resp.data.data.forEach(element => {

                            let slideshowVo = {
                                id: 0,
                                navName: '',
                                src: '',
                                contentTitle: '',
                                insertTime: ''
                            }
                            slideshowVo.src = this.serverUrl + this.prefiexUrl + element.contentPic;

                            slideshowVo.id = element.id;
                            slideshowVo.navName = element.navName;

                            slideshowVo.contentTitle = element.contentTitle;

                            if (element.insertTime != null) {
                                slideshowVo.insertTime = element.insertTime.substring(0, 10);
                            } else {
                                slideshowVo.insertTime = '暂无';
                            }

                            ArrayList.push(slideshowVo);
                        })

                        this.tableData = ArrayList;
                        this.loadingFlag = false;

                    }
                }).catch(err => {
                    this.$message({
                        message: '服务器繁忙！',
                        type: 'warning'
                    });
                })
            }
        }
    }
</script>


<style scoped>
    .floatDbg {
        width: 120px;
        height: 20px;
        background: url(../../../static/f/img/online_botbg.jpg) no-repeat;
    }

    .floatDtt {
        width: 120px;
        height: 45px;
        line-height: 45px;
        background: #00aeef;
        color: #fff;
        font-size: 18px;
        text-indent: 22px;
        position: relative;
    }

    #rightArrow {
        right: 120px;
        background-position: 0px 0px;
        width: 50px;
        height: 145px;
        background: url(../../../static/f/img/online_arrow.jpg) no-repeat;
        position: fixed;
        top: 180px;
        right: -5px;
        z-index: 9999;
        background-position: -50px 0;
    }

    #floatDivBoxs {
        right: 0px;
        width: 120px;
        background: #fff;
        position: fixed;
        top: 180px;
        right: -125px;
        z-index: 999;
    }

    .animationLeftExpose {
        animation: moveLeftExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    .animationRightExpose {
        animation: moveRightExpose 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    @keyframes moveLeftExpose {
        from {
            right: 0px;
        }

        to {
            right: 120px;
        }
    }

    @keyframes moveRightExpose {
        from {
            right: 120px;
        }

        to {
            right: 0px;
        }
    }

    .animationLeft {
        animation: moveLeft 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    .animationRight {
        animation: moveRight 0.3s linear;
        animation-iteration-count: 1;
        animation-fill-mode: forwards;

    }

    @keyframes moveLeft {
        from {
            right: -120px;
        }

        to {
            right: 0px;
        }
    }

    @keyframes moveRight {
        from {
            right: 0px;
        }

        to {
            right: -120px;
        }
    }

    .a {
        position: absolute;
        left: 0;
        top: 65px;
        min-width: 100%;
        line-height: 36px;
        padding: 5px 0;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12);
        border: 1px solid #d2d2d2;
        background-color: #fff;
        z-index: 100;
        border-radius: 2px;
        white-space: nowrap;
    }

    .bd {
        margin: 0 auto;
        width: 100% !important;
        position: relative;
        z-index: 0;
    }

    .mian {
        min-width: 1200px;
        padding-top: 15px;
    }

    .page_box {
        width: 100%;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
        clear: both;
    }

    .page_box_right {
        width: 1200px;
        height: auto;
        overflow: hidden;
        margin: 0 auto;
    }

    #fitslist {
        padding: 0 15px;
        min-height: 400px;
    }

    #fitslist .index_6_2_1_4 {
        width: 100%;
        height: 110px;
        padding-bottom: 25px;
        border-bottom: #eeeeee solid 1px;
        margin-top: 15px;
        float: left;
    }

    #fitslist .index_6_2_1_4_1 {
        width: 200px;
        height: 110px;
        overflow: hidden;
        text-align: center;
        float: left;
    }

    #fitslist .index_6_2_1_4_2 {
        width: 900px;
        height: 110px;
        padding: 0 15px;
        float: left;
    }

    .clearfix {
        display: block;
        clear: both;
    }
</style>


// WEBPACK FOOTER //
// src/components/internetplus/journalismNotice.vue